export enum TrustPilotWidgetSetup {
  SCRIPT_ELEMENT_ID = 'trust-pilot-widget-bootstrap',
  BUSINESS_UNIT_ID = '60fb0fb2e2dd1000016c090e'
}
